import { ToggleButton, Tooltip } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import React, { MouseEvent } from 'react';
import I18n from '../i18n/I18n';
import { Icons } from '../icons/Icons';
import { H } from '../Layout';
import StyledToggleButtonGroup from './StyledToggleButtonGroup';

const SaveCancelDeleteMenuItem = ({
    isSaveDisabled,
    isSaving,
    onSave,
    isDeleteDisabled,
    isDeleting,
    onDelete,
    onCancel
}) => {
    const buttons = [];
    if (typeof onSave === 'function') {
        const saveDisabled = isSaveDisabled || isSaving || isDeleting;
        buttons.push(
            <Tooltip
                key={'save'}
                title={<I18n token={isSaveDisabled ? 'common.required.content.error' : 'common.save'} />}
            >
                <ToggleButton
                    sx={{ cursor: saveDisabled ? 'not-allowed' : 'pointer' }}
                    value="save"
                    aria-label="save"
                    onClick={(event: MouseEvent<HTMLButtonElement>) => {
                        if (!saveDisabled) {
                            onSave(event);
                        }
                    }}
                >
                    {isSaving ? (
                        <CircularProgress size={12} />
                    ) : (
                        <Icons.Done color={saveDisabled ? 'disabled' : 'success'} fontSize={'small'} />
                    )}
                </ToggleButton>
            </Tooltip>
        );
    }
    if (typeof onCancel === 'function') {
        const cancelDisabled = isSaving || isDeleting;
        buttons.push(
            <Tooltip key={'cancel'} title={<I18n token={'common.cancel.editing'} />}>
                <ToggleButton
                    sx={{ cursor: cancelDisabled ? 'not-allowed' : 'pointer' }}
                    value="cancel"
                    aria-label="cancel"
                    onClick={(event: MouseEvent<HTMLButtonElement>) => {
                        if (!cancelDisabled) {
                            onCancel(event);
                        }
                    }}
                >
                    <Icons.Close fontSize={'small'} />
                </ToggleButton>
            </Tooltip>
        );
    }
    if (typeof onDelete === 'function') {
        const deleteDisabled = isDeleteDisabled || isSaving || isDeleting;
        buttons.push(
            <Tooltip
                key={'delete'}
                title={<I18n token={isDeleteDisabled ? 'notes.delete.disabled' : 'common.delete'} />}
            >
                <ToggleButton
                    sx={{ cursor: deleteDisabled ? 'not-allowed' : 'pointer' }}
                    value="delete"
                    aria-label="delete"
                    onClick={() => {
                        if (!deleteDisabled) {
                            onDelete();
                        }
                    }}
                >
                    {isDeleting ? <CircularProgress size={12} /> : <Icons.Delete fontSize={'small'} />}
                </ToggleButton>
            </Tooltip>
        );
    }

    return (
        <StyledToggleButtonGroup exclusive size={'small'} sx={{ mr: 1 }}>
            {buttons}
        </StyledToggleButtonGroup>
    );
};

export default ({ isSaveDisabled, isSaving, onSave, isDeleteDisabled, isDeleting, onDelete, onCancel }) => {
    return (
        <H passthroughprops={{ breakpoint: 600 }}>
            <SaveCancelDeleteMenuItem
                isSaveDisabled={isSaveDisabled}
                isSaving={isSaving}
                onSave={onSave}
                onDelete={onDelete}
                isDeleteDisabled={isDeleteDisabled}
                isDeleting={isDeleting}
                onCancel={onCancel}
            />
        </H>
    );
};
